export class CurrencyHelper {
  public static CentsToDollars = (cents: number): number => {
    return Number((cents / 100).toFixed(2));
  };
}
